export const JOURNEY_UPDATED = 'JOURNEY_UPDATED';
export const JOURNEY_RESET = 'JOURNEY_RESET';
export const JOURNEY_PROGRESS_RESET = 'JOURNEY_PROGRESS_RESET';
export const SESSION_INITIALISED = 'SESSION_INITIALISED';
export const JWT_SET = 'JWT_SET';
export const JWT_CLEARED = 'JWT_CLEARED';
export const LEAD_ID_SET = 'LEAD_ID_SET';
export const DOCUMENT_STATUSES_SET = 'DOCUMENT_STATUSES_SET';
